import { Icon } from "@sonaemc/mantra-react";

import Checkbox from "@/components/checkbox/Checkbox";

import { Consent } from "@/models/Consent";

type ConsentListProps = {
  title: string;
  consents?: Array<Consent>;
  /** Quando definido, cada linha rende um Checkbox e chama onToggle(id) ao clicar. */
  onToggle?: (id: string) => void;
};

export default function ConsentList({ title, consents, onToggle }: ConsentListProps) {
  if (!consents?.length) return null;

  return (
    <>
      <span className="font-bold">{title}</span>
      {consents.map(s =>
        <div key={s.id} className="flex px-8 gap-12 align-center justify-between">
          <div className="flex gap-12">
            <Icon size="lg" className="text-[var(--on-surface-variant)] self-center" name="StreamlineEmailsEnvelopeRegular" />
            <div className="flex flex-col">
              <span className="text-[var(--on-surface-variant)] text-base" dangerouslySetInnerHTML={{ __html: s.displayText }}></span>
              <span className="text-[var(--on-surface-default)] text-base font-medium ">{s.maskedValue}</span>
            </div>
          </div>
          {onToggle &&
            <Checkbox
              ariaLabel={s.displayText}
              onClick={() => onToggle(s.id)}
              defaultChecked
            />
          }
        </div>
      )}
    </>
  );
}
